import { type FC } from "react";

import { Logo } from "./logo";

export const Header: FC = () => (
  <header className="flex items-center justify-center">
    <Logo />
  </header>
);
